<script setup lang="ts">
const props = defineProps(["player"]);

function renderArmyList(player) {
  const list = player.armylist.split(/\n/);
  const matches = player.armylist_matched;
  let j = 0;

  let output = "";
  for (let k = 0; k < list.length; k++) {
    const line = list[k];
    for (let i = 0; i < line.length; i++) {
      if (j >= 0 && matches[j].line === k && i === matches[j].start) {
        output += `<a href="https://39k.pro/datasheet/${matches[j].id}" target="_blank">`;
        output += line.substring(i, matches[j].end);
        output += "</a>";
        i += matches[j].end - matches[j].start - 1;
        j++;
        if (j > matches.length - 1) {
          j = -1;
        }
      } else if (line[i] === "&") {
        output += "&amp;";
      } else if (line[i] === "<") {
        output += "&lt;";
      } else if (line[i] === ">") {
        output += "&gt;";
      } else {
        output += line[i];
      }
    }
    output += "\n";
  }

  return output;
}
</script>

<template>
  <div class="section" v-if="player">
    <div class="columns">
      <div class="column is-4">
        <h4>Path</h4>
        <ol>
          <li v-for="game in player?.games">
            <template v-if="player.player_bcp_id == game.player1_bcp_id">
              {{
                game.player2_game_result == "0"
                  ? "Win"
                  : game.player2_game_result == "1"
                  ? "Draw"
                  : "Loss"
              }}
              -
              <NuxtLink :to="'/list/' + game.player2_bcp_id">
                {{ game.player2_faction }}
              </NuxtLink>
            </template>
            <template v-else>
              {{
                game.player1_game_result == "0"
                  ? "Win"
                  : game.player2_game_result == "1"
                  ? "Draw"
                  : "Loss"
              }}
              -
              <NuxtLink :to="'/list/' + game.player1_bcp_id">
                {{ game.player1_faction }}
              </NuxtLink>
            </template>
          </li>
        </ol>
      </div>
      <div class="column is-8">
        <div class="armylist" v-html="renderArmyList(player)"></div>
      </div>
    </div>
  </div>
</template>
